import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomeVisitReport } from "../../../store/slices/reportSlice";
import HomeVisitList from "./HomeVisitList";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import MainLayout from "../../../components/layout/MainLayout";

const HomeVisitReports = () => {
  const dispatch = useDispatch();
  const { homeVisitReport, homeVisitYTD, isLoading } = useSelector((state) => state.reports);

  const [showFilters, setShowFilters] = useState(false);
  const [tempFilters, setTempFilters] = useState({
    clientName: "",
    outcome: "",
    startDate: "",
    endDate: ""
  });
  const [activeFilters, setActiveFilters] = useState({
    clientName: "",
    outcome: "",
    startDate: "",
    endDate: ""
  });

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '31px',
      height: '31px',
      fontSize: '0.8125rem',
      borderRadius: '0.375rem',
      borderColor: '#d9dee3',
      '&:hover': { borderColor: '#d9dee3' }
    }),
    valueContainer: (base) => ({ ...base, padding: '0 8px', height: '31px' }),
    input: (base) => ({ ...base, margin: '0', padding: '0' }),
    indicatorsContainer: (base) => ({ ...base, height: '31px' }),
    dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
    clearIndicator: (base) => ({ ...base, padding: '2px' }),
    menu: (base) => ({ ...base, fontSize: '0.8125rem' }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#666ee8' : state.isFocused ? '#f5f5f9' : 'white',
      color: state.isSelected ? 'white' : '#566a7f',
      cursor: 'pointer',
    })
  };

  const outcomeOptions = [
    { value: "", label: "All Outcomes" },
    { value: "Residential", label: "Residential" },
    { value: "DRP", label: "DRP" },
    { value: "Referred to Unit B", label: "Referred" },
  ];

  useEffect(() => {
    dispatch(fetchHomeVisitReport(activeFilters));
  }, [dispatch, activeFilters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    setActiveFilters({ ...tempFilters });
  };

  const handleClear = () => {
    const cleared = {
      clientName: "",
      outcome: "",
      startDate: "",
      endDate: ""
    };
    setTempFilters(cleared);
    setActiveFilters(cleared);
  };

  return (
    <MainLayout>
      <Breadcrumbs />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Home Visit Reports</h4>
          <div>
            <button
              className={`btn btn-sm ${showFilters ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setShowFilters(!showFilters)}
            >
              <i className="ri-filter-line me-1"></i> {showFilters ? 'Hide Filters' : 'Filters'}
            </button>
          </div>
        </div>

        {/* Filters Accordion */}
        <div className={`collapse ${showFilters ? 'show' : ''}`}>
          <div className="px-4 py-3">
            <div className="card shadow-sm border">
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label small fw-bold">Client Name</label>
                    <input type="text" name="clientName" className="form-control form-control-sm" placeholder="Search client..." value={tempFilters.clientName} onChange={handleFilterChange} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small fw-bold">Outcome</label>
                    <Select
                      options={outcomeOptions}
                      styles={selectStyles}
                      value={outcomeOptions.find(opt => opt.value === tempFilters.outcome)}
                      onChange={(opt) => setTempFilters(prev => ({ ...prev, outcome: opt.value }))}
                      placeholder="Select Outcome"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold">Start Date</label>
                    <input type="date" name="startDate" className="form-control form-control-sm" value={tempFilters.startDate} onChange={handleFilterChange} />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold">End Date</label>
                    <input type="date" name="endDate" className="form-control form-control-sm" value={tempFilters.endDate} onChange={handleFilterChange} />
                  </div>
                  <div className="col-md-2 d-flex align-items-end gap-2">
                    <button className="btn btn-sm btn-label-secondary w-50" onClick={handleClear}>Clear</button>
                    <button className="btn btn-sm btn-primary w-50" onClick={handleSubmit}>Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <HomeVisitList 
          data={homeVisitReport} 
          ytdTotal={homeVisitYTD}
          filters={activeFilters} 
          isLoading={isLoading} 
        />
      </div>
    </MainLayout>
  );
};

export default HomeVisitReports;
